import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../Include/Header";
import Sidebar from "../../Include/Sidebar";
import Footer from "../../Include/Footer";
import { useDispatch, useSelector } from "react-redux";
import { viewMaterialReceiveData } from "../../../../Store/Erp/MaterialReceive/ViewMaterialData";
import moment from "moment";

const displayValue = (val) => val || "-";

const ReadOnlyInput = ({
  label,
  value,
  colClass = "col-12 col-md-4 col-xl-4",
}) => (
  <div className={`mb-2 ${colClass}`}>
    <label className="form-label fw-semibold text-secondary small">
      {label}
    </label>
    <input
      className="form-control "
      value={displayValue(value)}
      readOnly
      style={{
        backgroundColor: "#f8f9fa",
        border: "1px solid #dee2e6",
        color: "#495057",
      }}
    />
  </div>
);

const ViewMaterialReceive = () => {
  const navigate = useNavigate();
  const { state: data } = useLocation();
  const dispatch = useDispatch();

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleOpen = () => setIsSidebarOpen(!isSidebarOpen);

  useEffect(() => {
    const fetchItemData = async () => {
      const payload = {
        issue_main_id: data?._id,
      };

      try {
        await dispatch(viewMaterialReceiveData(payload));
      } catch (err) {
        console.log(err);
      }
    };

    fetchItemData();
  }, []);

  const entity = useSelector(
    (state) => state?.viewMaterialReceiveData?.user?.data
  );

  const itemList = entity?.list || [];

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/user/project-store/dashboard">Dashboard</a>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right"></i>
                  </li>
                  <li className="breadcrumb-item active">
                    View Material Receive
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* ------------------ VIEW FORM ------------------ */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card p-4">
                <div className="card-header p-0 mb-4">
                  <h4 className="mb-0 text-primary">
                    <i className="fas fa-clipboard-list me-2"></i>
                    Material Receive Details
                  </h4>
                </div>
                <div className="card-body p-0">
                  <div className="row">
                    <ReadOnlyInput
                      label="Date"
                      value={moment(data?.date).format("DD-MM-YYYY")}
                    />
                    <ReadOnlyInput
                      label="Voucher No"
                      value={data?.voucher_no}
                    />
                    <ReadOnlyInput
                      label="Received By"
                      value={data?.received_by?.user_name}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ------------------ ITEM DETAILS ACCORDION ------------------ */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card py-3 px-1">
                <div className="card-header p-0">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="px-3 py-2">
                      <h4 className="mb-0 text-primary font-bold">
                        <i className="fas fa-boxes me-2"></i>
                        Item Details
                      </h4>
                    </div>
                    <span className="badge bg-white text-primary rounded-pill px-3 py-2 fs-6 fw-bold">
                      {itemList?.length} Items
                    </span>
                  </div>
                </div>

                <div className="card-body p-1 mt-2 mt-sm-0 p-sm-3">
                  <div
                    className="accordion accordion-flush"
                    id="itemsAccordion"
                  >
                    {itemList?.map((item, idx) => (
                      <div
                        key={idx}
                        className="accordion-item border rounded-3 mb-3"
                      >
                        <h2 className="accordion-header" id={`heading${idx}`}>
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#collapse${idx}`}
                            aria-expanded="false"
                            aria-controls={`collapse${idx}`}
                            style={{
                              backgroundColor: "#fff",
                              borderRadius: "0.5rem",
                              padding: "1rem",
                            }}
                          >
                            <div className="d-flex justify-content-between align-items-center w-100 me-3">
                              <div className="d-flex align-items-center gap-3">
                                <div
                                  className="d-flex align-items-center justify-content-center text-white fw-bold rounded-circle"
                                  style={{
                                    width: "42px",
                                    height: "42px",
                                    background: "var(--primary-clr)",
                                  }}
                                >
                                  {idx + 1}
                                </div>
                                <div>
                                  <h6
                                    className="mb-0"
                                    style={{
                                      fontWeight: "500",
                                      fontSize: "15px",
                                      color: "#333447",
                                    }}
                                  >
                                    {`${item?.itemDetailsData?.name} (Unit: ${
                                      item?.uomData?.name || "-"
                                    }) ${
                                      item?.itemDetailsData?.category
                                        ? `(Category: ${item?.itemDetailsData?.category})`
                                        : ""
                                    } `}
                                  </h6>
                                </div>
                              </div>
                              <div className="d-flex align-items-center gap-4">
                                <div className="d-none d-sm-block">
                                  {item.is_qc ? (
                                    <span
                                      style={{
                                        background: "var(--primary-clr)",
                                      }}
                                      className="badge rounded-pill px-3 py-2"
                                    >
                                      <i className="fas fa-check-circle me-1"></i>
                                      With QC
                                    </span>
                                  ) : (
                                    <span className="badge bg-danger text-white rounded-pill px-3 py-2">
                                      <i className="fas fa-clock me-1"></i>
                                      without QC
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </button>
                        </h2>
                        <div
                          id={`collapse${idx}`}
                          className="accordion-collapse collapse"
                          aria-labelledby={`heading${idx}`}
                          data-bs-parent="#itemsAccordion"
                        >
                          <div
                            className="accordion-body"
                            style={{ backgroundColor: "#fafbfc" }}
                          >
                            {/* Basic Information Section */}
                            <div className="mb-1">
                              <h6
                                className="text-uppercase text-primary fw-bold mb-2"
                                style={{
                                  fontSize: "0.875rem",
                                }}
                              >
                                <i className="fas fa-info-circle me-2"></i>Basic
                                Information
                              </h6>
                              <div className="row">
                                <ReadOnlyInput
                                  label="Item Name"
                                  value={item?.itemDetailsData?.name || "-"}
                                  colClass="col-6  col-md-4 col-xl-2"
                                />
                                <ReadOnlyInput
                                  label="Unit"
                                  value={item?.uomData?.name || "-"}
                                  colClass="col-6  col-md-4 col-xl-2"
                                />
                                <ReadOnlyInput
                                  label="Category"
                                  value={item?.itemDetailsData?.category || "-"}
                                  colClass="col-6  col-md-4 col-xl-2"
                                />
                                <ReadOnlyInput
                                  label="Received Qty"
                                  value={item.receive_quantity || "-"}
                                  colClass="col-6  col-md-4 col-xl-2"
                                />
                                <ReadOnlyInput
                                  label="Accepted Qty"
                                  value={item.quantity || "-"}
                                  colClass="col-6  col-md-4 col-xl-2"
                                />
                                <ReadOnlyInput
                                  label="Lot No."
                                  value={item.lot_no || "-"}
                                  colClass="col-6  col-md-4 col-xl-2"
                                />
                              </div>
                            </div>

                            {/* Dimensions Section */}
                            <div className="mb-1">
                              <h6
                                className="text-uppercase text-primary fw-bold mb-2"
                                style={{
                                  fontSize: "0.875rem",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                <i className="fas fa-ruler-combined me-2"></i>
                                Dimensions
                              </h6>
                              <div className="row">
                                <ReadOnlyInput
                                  label="NOS"
                                  value={item.nos || "-"}
                                  colClass="col-6 col-md-4 col-xl-2"
                                />
                                <ReadOnlyInput
                                  label="Heat No"
                                  value={item.heat_no || "-"}
                                  colClass="col-6 col-md-4 col-xl-2"
                                />
                                <ReadOnlyInput
                                  label="Length (mm)"
                                  value={item.length || "-"}
                                  colClass="col-6 col-md-4 col-xl-2"
                                />
                                <ReadOnlyInput
                                  label="Width (mm)"
                                  value={item.width || "-"}
                                  colClass="col-6 col-md-4 col-xl-2"
                                />
                                <ReadOnlyInput
                                  label="Top/Bottom Thickness (mm)"
                                  value={item.topbottom_thickness || "-"}
                                  colClass="col-6 col-md-4 col-xl-2"
                                />
                                <ReadOnlyInput
                                  label="Width Thickness (mm)"
                                  value={item.width_thickness || "-"}
                                  colClass="col-6 col-md-4 col-xl-2"
                                />
                                <ReadOnlyInput
                                  label="Normal Thickness (mm)"
                                  value={`${item.normal_thickness}` || "-"}
                                  colClass="col-6 col-md-4 col-xl-2"
                                />
                                <ReadOnlyInput
                                  label="UOM"
                                  value={item?.uomData?.name}
                                  colClass="col-6 col-md-4 col-xl-2"
                                />
                              </div>
                            </div>

                            {/* Quality Control Section */}
                            {item?.is_qc === true ? (
                              <div className="mb-2">
                                <h6
                                  className="text-uppercase text-primary fw-bold mb-2"
                                  style={{
                                    fontSize: "0.875rem",
                                    letterSpacing: "0.5px",
                                  }}
                                >
                                  <i className="fas fa-clipboard-check me-2"></i>
                                  Quality Control
                                </h6>
                                <div className="row">
                                  <ReadOnlyInput
                                    label="QC Status"
                                    value={item.is_qc ? "Approved" : " Pending"}
                                    colClass="col-6 col-md-4 col-xl-2"
                                  />
                                  <ReadOnlyInput
                                    label="QC NOS"
                                    value={item.qc_nos || "-"}
                                    colClass="col-6 col-md-4 col-xl-2"
                                  />
                                  <ReadOnlyInput
                                    label="QC Length (mm)"
                                    value={`${item.qc_length || "-"}`}
                                    colClass="col-6 col-md-4 col-xl-2"
                                  />
                                  <ReadOnlyInput
                                    label="QC Width (mm)"
                                    value={`${item.qc_width || "-"}`}
                                    colClass="col-6 col-md-4 col-xl-2"
                                  />
                                  <ReadOnlyInput
                                    label="TC No"
                                    value={item.tc_no || "-"}
                                    colClass="col-6 col-md-4 col-xl-2"
                                  />
                                  <ReadOnlyInput
                                    label="QC Top/Bottom Thickness (mm)"
                                    value={item.qc_topbottom_thickness || "-"}
                                    colClass="col-6 col-md-4 col-xl-2"
                                  />
                                  <ReadOnlyInput
                                    label="QC Width Thickness (mm)"
                                    value={item.qc_width_thickness || "-"}
                                    colClass="col-6 col-md-4 col-xl-2"
                                  />
                                  <ReadOnlyInput
                                    label="QC Normal Thickness (mm)"
                                    value={item.qc_normal_thickness || "-"}
                                    colClass="col-6 col-md-4 col-xl-2"
                                  />
                                  <ReadOnlyInput
                                    label="QC Lot No."
                                    value={item.qc_lot_no || "-"}
                                    colClass="col-6 col-md-4 col-xl-2"
                                  />
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {item?.is_qc && item?.rej_quantity > 0 && (
                              <div className="mb-2">
                                <h6
                                  className="text-uppercase text-primary fw-bold mb-2"
                                  style={{
                                    fontSize: "0.875rem",
                                    letterSpacing: "0.5px",
                                  }}
                                >
                                  <i className="fas fa-times me-2"></i>
                                  Rejected Item Details
                                </h6>
                                <div className="row">
                                  <ReadOnlyInput
                                    label="Rejected Qty"
                                    value={item?.rej_quantity || "-"}
                                    colClass="col-6 col-md-4 col-xl-2"
                                  />
                                  <ReadOnlyInput
                                    label="Rejected Legth (mm)"
                                    value={item?.rej_length || "-"}
                                    colClass="col-6 col-md-4 col-xl-2"
                                  />
                                  <ReadOnlyInput
                                    label="Rejected Width (mm)"
                                    value={item?.rej_width || "-"}
                                    colClass="col-6 col-md-4 col-xl-2"
                                  />
                                </div>
                              </div>
                            )}

                            {/* Remarks Section */}
                            {item?.qc_remarks && (
                              <div>
                                <h6
                                  className="text-uppercase text-primary fw-bold mb-2"
                                  style={{
                                    fontSize: "0.875rem",
                                    letterSpacing: "0.5px",
                                  }}
                                >
                                  <i className="fas fa-comment-dots me-2"></i>
                                  QC Remarks
                                </h6>
                                <div className="row">
                                  <div className="col-12 mb-3">
                                    <textarea
                                      className="form-control"
                                      value={displayValue(item.qc_remarks)}
                                      readOnly
                                      rows="3"
                                      style={{
                                        backgroundColor: "#f8f9fa",
                                        border: "1px solid #dee2e6",
                                        color: "#495057",
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}

                            <div>
                              <h6
                                className="text-uppercase text-primary fw-bold mb-2"
                                style={{
                                  fontSize: "0.875rem",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                <i className="fas fa-comment-dots me-2"></i>
                                Remarks
                              </h6>
                              <div className="row">
                                <div className="col-12 mb-3">
                                  <textarea
                                    className="form-control"
                                    value={displayValue(item.remarks)}
                                    readOnly
                                    rows="3"
                                    style={{
                                      backgroundColor: "#f8f9fa",
                                      border: "1px solid #dee2e6",
                                      color: "#495057",
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="col-12 text-end">
                    <div className="doctor-submit text-end">
                      <button
                        type="button"
                        className="btn btn-primary submit-form me-2"
                        onClick={() =>
                          navigate(
                            "/user/project-store/item-receive-management"
                          )
                        }
                      >
                        Back
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ViewMaterialReceive;
